import { useEffect, useState } from 'react';

import { BordSortSelect, TSortOrder } from 'bord-design-system';

export type TInputOnSort = { sortData: string[]; sortValues: string[] };

interface IQuotesSort {
  initialSortBy?: string;
  initialSortOrder?: string;
  onSort?: (values: TInputOnSort) => void;
}

const SORTABLE_ITEMS = [
  { id: 'createdAt', label: 'Fecha de creación' },
  { id: 'numberOfProducts', label: 'Número de productos' }
];

const CONFIG_BY_OPTION_ID: Record<string, { ascLabel: string; descLabel: string }> = {
  createdAt: {
    ascLabel: 'Más antiguos primero',
    descLabel: 'Más recientes primero'
  },
  numberOfProducts: {
    ascLabel: 'Menos productos',
    descLabel: 'Más productos'
  }
};

export const QuotesSort = ({ initialSortBy, initialSortOrder, onSort }: IQuotesSort) => {
  const [opened, setOpened] = useState(false);
  const [sortOptionSelected, setSortOptionSelected] = useState(initialSortBy || 'createdAt');
  const [selections, setSelections] = useState(() => {
    const map = new Map<string, TSortOrder>();
    if (initialSortBy && initialSortOrder) {
      map.set(initialSortBy, initialSortOrder as TSortOrder);
    }
    return map;
  });

  /**
   * Sincroniza el ordenamiento visual cuando se rehidrata desde la URL.
   */
  useEffect(() => {
    if (!initialSortBy) {
      setSelections(new Map());
      return;
    }

    setSortOptionSelected(initialSortBy);
    setSelections(initialSortOrder ? new Map([[initialSortBy, initialSortOrder as TSortOrder]]) : new Map());
  }, [initialSortBy, initialSortOrder]);

  const handleSort = (value: TSortOrder) => {
    const id = sortOptionSelected;
    const map = new Map();

    if (map.has(id) && map.get(id) && map.get(id) === value) {
      map.delete(id);
    } else {
      map.set(id, value);
    }

    setSelections(map);

    const formatted = Object.fromEntries(map);

    onSort?.({ sortData: Object.keys(formatted), sortValues: Object.values(formatted) });
  };

  return (
    <BordSortSelect
      triggerLabel="Ordenar"
      selectedSortById={sortOptionSelected}
      order={selections.get(sortOptionSelected) as TSortOrder}
      isOpen={opened}
      onOpenChange={setOpened}
      onSortByChange={setSortOptionSelected}
      onOrderChange={handleSort}
      orderAscLabel={CONFIG_BY_OPTION_ID[sortOptionSelected]?.ascLabel || 'Ascendente'}
      orderDescLabel={CONFIG_BY_OPTION_ID[sortOptionSelected]?.descLabel || 'Descendente'}
      sortByOptions={SORTABLE_ITEMS}
    />
  );
};
